<template>
  <div id="app">
    <NavBar/>
    <router-view class="main-view"/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'home',
  components: {
    NavBar,
    Footer
  }
}
</script>


<style>
html {
  overflow-y: scroll;
  font-size: 14px;
}

#app {
  font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic", "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: calc(100vh - 65px);
  position: relative;
  box-sizing: border-box;
  padding-bottom: 93px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.main-view {
  padding-top: 55px;
  padding-bottom: 40px;
}


@media(max-width: 400px){
  .main-view {
    padding-top: 45px;
    padding-bottom: 40px;
  }
}
</style>
